export default __webpack_public_path__ + "static/media/bg.6912f1c5.webp";